export default "__VITE_ASSET__pGvkuavp__"